// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
        numberFilterTree: 2,
        showLimitList: '24,36,48'
    },
};

var quickViewModalLoaded = 0;

// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<li class="{{customClass}}  {{itemBadgeVE}}" data-product-item tabindex="1">' +
                            '{{itemBadgeRx_vto}}' +
                                '<div id="{{itemHandle}}" class="productitem" data-product-item-content>' +
                                    '<a class="productitem--image-link" href="{{itemUrl}}">' +
                      
                '{{customNewLabel_vto}}' +
                            '{{customNewLabel_iva_img}}' +
                                        '<figure class="productitem--image" data-product-item-image>' +
                                            '{{itemBadgeEE}}' +
                                            '<img alt="{{itemTitle}}" src="{{itemThumbUrl}}">' +
                                            '{{flipImage}}' +
                                        '</figure>' +
                                    '</a>' +
                                    '<div class="productitem--info">' +
                                    '{{itemLabels}}' + '{{itemBadgeColl}}' + '{{itemBadgeGc}}' + '{{itemSlogan}}'  + '{{itemMeta}}' +  '{{itemPromoLC}}' +
                      '{{customNewLabel_iva}}' +
                                        '{{emphasizePrice}}'  +
                      '{{itemMeta_price}}' +
                                        '<p class="productitem--title">' +
                                            '<a href="{{itemUrl}}" tabindex="1">' +
                                                '{{itemTitle}}' +
                                            '</a>' +
                                        '</p>' +
                                        '{{noEmphasizePrice}}'  +
                                        '{{itemVendor}} <br>' +
                                        '{{itemReplace}}' +
                                        '{{itemReviews}}' +
                                    '</div>' +
                                    '{{quickBtn}}' +
                                '</div>' +
                            '</li>',

    // List Template
    'productListItemHtml': '<li class="{{customClass}}">' +
                                '<div id="{{itemHandle}}" class="productitem">' +
                                    '<a class="productitem--image-link" href="{{itemUrl}}">' + 
                      '{{itemBadge}}' +
                                        '<figure class="productitem--image" data-product-item-image>' +
                                            '<img alt="{{itemTitle}}" src="{{itemThumbUrl}}">' +
                                            '{{itemLabels}}' +
                                        '</figure>' +
                                    '</a>' +
                                    '<div class="productitem--info">' +
                                        '{{emphasizePrice}}'  +
                                        '<p class="productitem--title">' +
                                            '<a href="{{itemUrl}}" tabindex="1">' +
                                                '{{itemTitle}}' +
                                            '</a>' +
                                        '</p>' +
                                        '{{noEmphasizePrice}}'  +
                                        '{{itemVendor}} <br>' +
                                        '{{itemReplace}}' +
                                        '{{itemReviews}}' +
                                        '{{itemDescription}}' +
                                    '</div>' +
                                    '{{quickBtn}}' +
                                '</div>' +
                            '</li>',

    // Pagination Template
    'previousActiveHtml': '<li class="pagination--previous"><a class="pagination--item" href="{{itemUrl}}"><span class="pagination--chevron-left" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span>' + bcSfFilterConfig.label.prev + '</a></li>',
    'previousDisabledHtml': '',
    'nextActiveHtml': '<li class="pagination--next"><a class="pagination--item" href="{{itemUrl}}">' + bcSfFilterConfig.label.next + '<span class="pagination--chevron-right" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg></span></a></li>',
    'nextDisabledHtml': '',
    'pageItemHtml': '<li><a class="pagination--item" href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="pagination--active"><span class="pagination--item">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li class="pagination--ellipsis"><span class="pagination--item">{{itemTitle}}</span></li>',
    'paginateHtml': '<div class="pagination--container"><ul class="pagination--inner">{{previous}}{{pageItems}}{{next}}</ul></div>',

    // Sorting Template
  //'sortingHtml':  '<label class="utils-sortby-title" for="product_grid_sort">' + bcSfFilterConfig.label.sorting + '</label>' +
  'sortingHtml':  '<label class="utils-sortby-title" for="product_grid_sort">Ordenar por:</label>' +
                    '<div class="utils-sortby-select form-field-select-wrapper no-label">' +
                        '<select class="form-field form-field-select">{{sortingItems}}</select>' +
                        '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" > <g fill="currentColor" fill-rule="evenodd"> <polygon class="icon-chevron-down-left" points="4 5.371 7.668 1.606 6.665 .629 4 3.365"/> <polygon class="icon-chevron-down-right" points="4 3.365 1.335 .629 1.335 .629 .332 1.606 4 5.371"/> </g> </svg>' +
                    '</div>',

    // Show limit Template
    'showLimitHtml': '<li><span class="utils-showby-title">' + bcSfFilterConfig.label.show_per_page + '</span></li>{{showLimitItems}}',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  
  

    // Add custom class
    var customClass = 'productgrid--item imagestyle--' + bcSfFilterConfig.custom.product_grid_image_style;
    if (onSale) customClass += ' productitem--sale';
    if (bcSfFilterConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
    itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '512x') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
  
    // Add Thumbnail
    //acá controlamos si queremos que se vea la segunda imagen o no, con modificar el if es suficiente, yo le queité esto porque era lo que hacía que no funcionara (+bcSfFilterConfig.custom.product_grid_show_second_image), pero debería estar porque se complementa con la info (el checkbox booleano) que hay en el personalizador
    var itemFlipImage = images.length > 1 && data.product_type != 'Lentes de Contacto' ? '<img alt="{{itemTitle}}" src=" '+ this.optimizeImage(images[1]['src']) +' " class="productitem--image-alternate">'  : '';
    //console.log(images.length);
    itemHtml = itemHtml.replace(/{{flipImage}}/g, itemFlipImage);

    //Etiqueta Producto Nuevo
    //Actualmente Freegen y Dailies Toricos
    if (data.id == '7104630620218') {
        var itemFree = '';
        itemFree += '<div style="z-index:5;margin-bottom: -1rem;position: relative;"align="center"><span class="promotionTag" style="padding: 5px 15px; line-height: 1.3;">¡Nuevo!</span></div>'; 
        itemHtml = itemHtml.replace(/{{itemSlogan}}/g, itemFree);
    }

    function buildNewLabel_promoLC(data){
        var showNewBadge_promoLC = data.collections.find(item => item.title === 'Lentes de contacto iWear');
        var itemPromoLC = "";
        if(showNewBadge_promoLC){
           //if( data.id != '4547352166458') {itemPromoLC += '<div style="z-index:5;margin-bottom: -1rem;position: relative; top:20px;"align="center"><span class="promotionTag" style="padding: 5px 15px; line-height: 1.3;">Compra 2 cajas y recibe Gafas de sol (Referencias seleccionadas)</span></div>';}
        }
        return itemPromoLC;
      }
    itemHtml = itemHtml.replace(/{{itemPromoLC}}/g, buildNewLabel_promoLC(data));


    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //-------------------------------------------------------------------LENTES DE CONTACTO---------------------------------------------------------
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
    if(data.product_type == 'Lentes de Contacto' || data.product_type == 'Lentes Cosméticos'){

    //Etiquetas LC
    var itemMeta = '';
    var itemMeta_flag = bcsffilter.getProductMetafield(data, 'custom', 'flag_promo');
    //if(itemMeta_flag == 'true'){
        var itemMeta_value = bcsffilter.getProductMetafield(data, 'custom', 'etiqueta_promocion');
        if(itemMeta_value == null){
            itemMeta += '';
        }else{
            var itemMeta_array = itemMeta_value.split('","');
            var itemMeta_text = '';
            for(var i_array = 0; i_array < itemMeta_array.length; i_array++){
                itemMeta_array[i_array] = itemMeta_array[i_array].replace('[', ''); 
                itemMeta_array[i_array] = itemMeta_array[i_array].replace(']', ''); 
                itemMeta_array[i_array] = itemMeta_array[i_array].replace('"', '');
               itemMeta_array[i_array] = itemMeta_array[i_array].replace('"', '');
          
                if(i_array == 0){
                  itemMeta_text += itemMeta_array[i_array];
                }else{
                  itemMeta_text += '<br>'+itemMeta_array[i_array];
                }   
            }
            itemMeta += '<div style="z-index:5;margin-bottom: -1rem;position: relative;"align="center"><span class="promotionTag" style="padding: 5px 15px; line-height: 1.3;">'+itemMeta_text+'</span></div>'; 
        }
    //}
  
    itemHtml = itemHtml.replace(/{{itemMeta}}/g, itemMeta);

    //Slogan LC
    var itemSlogan = '';
    var itemSlogan_value = bcsffilter.getProductMetafield(data, 'custom', 'etiqueta_slogan');
    if(itemSlogan_value != null){
        if (itemMeta_value == null) { //Este If evita que se solape esta etiqueta con la Etiquetas LC (itemMeta) de arriba, en caso de existir itemMeta, esta no se muestra
            itemSlogan += '<div style="z-index:5;margin-bottom: -1rem;position: relative;"align="center"><span class="promotionTag" style="padding: 5px 15px; line-height: 1.3;">'+itemSlogan_value+'</span></div>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemSlogan}}/g, itemSlogan);

    //Precios LC
    var itemMeta_price = '';
    if(itemMeta_flag == 'true'){ //Viene de la variable de arriba
      //Tachado de precio original
      var itemMeta_style = bcsffilter.getProductMetafield(data, 'custom', 'precio_original');
      var itemMeta_style_text = '';
      if(itemMeta_style == 'true'){
        //RECORDAR LASIK
        if (data.tags.indexOf("Lasik")> -1){itemMeta_style_text += '<style>#tienda-online-examenes-pre-lasik-150 .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}

        if (data.tags.indexOf("acuvue_1dam")> -1){itemMeta_style_text += '<style>#tienda-online-1-day-acuvue-moist .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("acuvue_1dam_ast")> -1){itemMeta_style_text += '<style>#tienda-online-1-day-acuvue-moist-astigmatismo .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("acuvue_ao")> -1){itemMeta_style_text += '<style>#tienda-online-acuvue-oasys .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("acuvue_aoa")> -1){itemMeta_style_text += '<style>#tienda-online-acuvue-oasys-for-astigmatism .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("acuvue_a2")> -1){itemMeta_style_text += '<style>#acuvue-2 .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("acuvue_vit")> -1){itemMeta_style_text += '<style>#acuvue-vita .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("acuvue_vitast")> -1){itemMeta_style_text += '<style>#acuvue-vita-astigmatismo .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("acuvue_oamult")> -1){itemMeta_style_text += '<style>#acuvue-oasys-multifocal .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        
        if (data.tags.indexOf("iw_oxygen")> -1){itemMeta_style_text += '<style>#tienda-online-i-wear-oxygen .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("iw_oxygen_ast")> -1){itemMeta_style_text += '<style>#i-wear-oxygen-astigmatismo .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("iw_oxygen_xr")> -1){itemMeta_style_text += '<style>#i-wear-oxygen-xr .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("iw_oxygen_xr_ast")> -1){itemMeta_style_text += '<style>#i-wear-oxygen-xr-astigmatismo .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("iw_fresh")> -1){itemMeta_style_text += '<style>#tienda-online-iwear-fresh .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("iw_slim")> -1){itemMeta_style_text += '<style>#i-wear-slim .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("iw_connect")> -1){itemMeta_style_text += '<style>#i-wear-connect .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("iw_go")> -1){itemMeta_style_text += '<style>#i-wear-go .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
          
        if (data.tags.indexOf("ao_aqua")> -1){itemMeta_style_text += '<style>#tienda-online-air-optix-aqua .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("ao_daynight")> -1){itemMeta_style_text += '<style>#air-optix-night-day-aqua .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("ao_hydra")> -1){itemMeta_style_text += '<style>#tienda-online-airoptix-plus-hydraglyde .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("ao_hydra_ast")> -1){itemMeta_style_text += '<style>#air-optix-for-astigmatism .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("ao_hydra_multifocal")> -1){itemMeta_style_text += '<style>#air-optix-hydraglyde-multifocal .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("ao_multifocal")> -1){itemMeta_style_text += '<style>#air-optix-aqua-multifocal .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        if (data.tags.indexOf("precision_1")> -1){itemMeta_style_text += '<style>#precision-1 .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}
        
        if (data.tags.indexOf("dailies_esf")> -1){itemMeta_style_text += '<style>#tienda-online-dailies_aquacomfort-plus .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}  
        if (data.tags.indexOf("dailies_ast")> -1){itemMeta_style_text += '<style>#dailies-aquacomfort-plus-toric .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}  
        
        if (data.tags.indexOf("lc_biof")> -1){itemMeta_style_text += '<style>#biofinity-sphere .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}  
        if (data.tags.indexOf("lc_biofxr")> -1){itemMeta_style_text += '<style>#biofinity-xr .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}  
        if (data.tags.indexOf("lc_biofast")> -1){itemMeta_style_text += '<style>#biofinity-torico .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}  
        if (data.tags.indexOf("lc_biofastxr")> -1){itemMeta_style_text += '<style>#biofinity-xr-torico .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}  
        
        if (data.tags.indexOf("freshlook")> -1){itemMeta_style_text += '<style>#freshlook-color-blends-neutro .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}  
        if (data.tags.indexOf("ao_color")> -1){itemMeta_style_text += '<style>#tienda-online-air-optix-colors-neutro .price--main .money{text-decoration: line-through; font-size: 14px; color: #888;}</style>';}  
      }
      

      //Configuración de precios
      var itemMeta_price_value = bcsffilter.getProductMetafield(data, 'custom', 'valor_promocion');
      var itemMeta_price_array = itemMeta_price_value.split('","');
      var itemMeta_price_text = '';
      for(var j_array = 0; j_array < itemMeta_price_array.length; j_array++){
          itemMeta_price_array[j_array] = itemMeta_price_array[j_array].replace('[', ''); 
          itemMeta_price_array[j_array] = itemMeta_price_array[j_array].replace(']', ''); 
          itemMeta_price_array[j_array] = itemMeta_price_array[j_array].replace('"', '');
          itemMeta_price_array[j_array] = itemMeta_price_array[j_array].replace('"', '');  
          itemMeta_price_array[j_array] = itemMeta_price_array[j_array].replace('|', '<br>');
        
          if(j_array == 0){
            itemMeta_price_text +=  '<br>'+itemMeta_price_array[j_array];
          }else{
            itemMeta_price_text += '<br><br>'+itemMeta_price_array[j_array];
          }   
      }

      itemMeta_price += itemMeta_style_text+'<span style="color: #0055b8;">'+itemMeta_price_text+'</span>'; 
    }

    itemHtml = itemHtml.replace(/{{itemMeta_price}}/g, itemMeta_price);

    }else{
        var itemMeta_price = '';
        var itemMeta = '';
        var itemSlogan = '';
        itemHtml = itemHtml.replace(/{{itemSlogan}}/g, itemSlogan);
        itemHtml = itemHtml.replace(/{{itemMeta}}/g, itemMeta);
        itemHtml = itemHtml.replace(/{{itemMeta_price}}/g, itemMeta_price);
    }


    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //-------------------------------------------------------------------COLECCIONES-----------------------------------------------------------------
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // Etiquetas para colecciones
    var itemBadgeColl = '';
    var collection_name_qty = bcSfFilterConfig.custom.collection_name_qty;
    if(collection_name_qty > 0){
        var collection_name = bcSfFilterConfig.custom.collection_name;
        var collection_tag = bcSfFilterConfig.custom.collection_tag;
        var collection_date = bcSfFilterConfig.custom.collection_date;
        var collection_color = bcSfFilterConfig.custom.color_tag;

        var coll_name = collection_name.split('|');
        var tag_label = collection_tag.split('|');
        var tag_date = collection_date.split('|');
        var coll_color = collection_color.split('|');

        for (var i = 0; i < collection_name_qty; i++) {
            var tag_date_split = tag_date[i].split('/');
            //ordenar fecha inicio a formato UTC (YYYY-MM-DD)
            var tag_date_init_full = tag_date_split[0];
            var tag_date_init_full_split = tag_date_init_full.split('-');
            var tag_date_init_string = tag_date_init_full_split[2]+'/'+tag_date_init_full_split[1]+'/'+tag_date_init_full_split[0];
            var tag_date_init = new Date(tag_date_init_string);
            //ordenar fecha culminación a formato UTC (YYYY-MM-DD)
            var tag_date_end_full = tag_date_split[1];
            var tag_date_end_full_split = tag_date_end_full.split('-');
            var tag_date_end_string = tag_date_end_full_split[2]+'/'+tag_date_end_full_split[1]+'/'+tag_date_end_full_split[0];
            var tag_date_end = new Date(tag_date_end_string);
            //ordenar fecha actual a formato UTC (YYYY-MM-DD)
            var js_today = new Date();
            var js_dd = String(js_today.getDate()).padStart(2, '0');
            var js_mm = String(js_today.getMonth() + 1).padStart(2, '0'); //Enero es 0!
            var js_yyyy = js_today.getFullYear();
            js_today = js_yyyy+ '/' +js_mm+ '/'+ js_dd;
            var today_date = new Date(js_today);

            if (tag_date_init <= today_date && today_date <= tag_date_end) {
                var coll_i = data.collections.find(item => item.title === coll_name[i]);
                if(coll_i){itemBadgeColl += '<div class="promotionBoxTag"><span class="promotionTag" style="background-color:'+coll_color[i]+'">'+tag_label[i]+'</span></div> '; break;}  
            } 
        }
    }

    itemHtml = itemHtml.replace(/{{itemBadgeColl}}/g, itemBadgeColl);

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //-------------------------------------------------------------------GIFT CARDS------------------------------------------------------------------
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //Usaremos itemBadgeColl ya que no puede haber 
    //promos de colecciones y GC al mismo tiempo, 
    //asi que itemBadgeColl siempre estará disponible
    var itemBadgeGc = '';
    var gc_perc = bcSfFilterConfig.custom.gc_percentage;
    if (gc_perc > 0) {
        //ordenar fecha inicio a formato UTC (YYYY-MM-DD)
        var gc_date_init_full = bcSfFilterConfig.custom.gc_init;
        var gc_date_init_full_split = gc_date_init_full.split('-');
        var gc_date_init_string = gc_date_init_full_split[2]+'/'+gc_date_init_full_split[1]+'/'+gc_date_init_full_split[0];
        var gc_date_init = new Date(gc_date_init_string);
        //ordenar fecha culminación a formato UTC (YYYY-MM-DD)
        var gc_date_end_full = bcSfFilterConfig.custom.gc_end;
        var gc_date_end_full_split = gc_date_end_full.split('-');
        var gc_date_end_string = gc_date_end_full_split[2]+'/'+gc_date_end_full_split[1]+'/'+gc_date_end_full_split[0];
        var gc_date_end = new Date(gc_date_end_string);
        //ordenar fecha actual a formato UTC (YYYY-MM-DD)
        var gc_today = new Date();
        var gc_dd = String(gc_today.getDate()).padStart(2, '0');
        var gc_mm = String(gc_today.getMonth() + 1).padStart(2, '0'); //Enero es 0!
        var gc_yyyy = gc_today.getFullYear();
        gc_today = gc_yyyy+ '/' +gc_mm+ '/'+ gc_dd;
        var today_date = new Date(gc_today);

        //ACTUALMENTE NO SE USA PERO PODRÍA SER UTIL LUEGO
        // if (gc_date_init <= today_date && today_date <= gc_date_end) {
        //     var coll_gc = data.collections.find(item => item.title === 'TARJETAS DE REGALO');
        //     if(coll_gc){
        //         itemBadgeGc += '<div class="promotionBoxTag"><span class="promotionTag" style="margin-top: 20px;">'+gc_perc+'% Descuento</span></div>';
        //     }  
        // }
    }
    itemHtml = itemHtml.replace(/{{itemBadgeGc}}/g, itemBadgeGc);   


    //Add Sun Rx
    var itemBadgeRx_vto = '';
    if (data.tags.indexOf("sol-rx")> -1){
        itemBadgeRx_vto += '<img src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/TAG-SOL-RX-PNG.png?v=1648058155" class="tag-rx">';
    }else{
        if (data.tags.indexOf("VMx")> -1){
          itemBadgeRx_vto += '<img src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/1_PRUEBA_TUS_GAFAS.png?v=1661868151" class="tag-rx" style="max-width: 35px !important;">';
        }
    }
  
    itemHtml = itemHtml.replace(/{{itemBadgeRx_vto}}/g, itemBadgeRx_vto);
  
    //Add Shipping
    var itemBadgeVE = '';
    if (data.tags.indexOf("SHIPPING-VE")> -1){
      itemBadgeVE += 'hide-ve';
    }
  
    itemHtml = itemHtml.replace(/{{itemBadgeVE}}/g, itemBadgeVE);
  
    //Add Envío Express
    var itemBadgeEE = '';
    if (data.tags.indexOf("express")> -1){
      //itemBadgeEE += '<img src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/ENVIO-EXPRESS.png?v=1650309900" class="tag-rx">';
    }
    itemHtml = itemHtml.replace(/{{itemBadgeEE}}/g, itemBadgeEE);
  
    // Add Badge
    var itemBadgeHtml = '';
    var precio_new = data.price / 100000;
    var ese_color_cyan = 'background-color:#39bac0';
 
    if (data.tags.indexOf("Niño")> -1){
      itemBadgeHtml += '<div style="  z-index:5;position: relative;"align="center"><span class="promotionTag">NIÑOS</span><br><br></div>';
    }

    
    //------------------------------------------------------------------------------------------------------------------------------------
    //                                                             DÍAS SIN IVA
    //------------------------------------------------------------------------------------------------------------------------------------

    // Etiquetas superiores 
    function buildNewLabel_iva_img(data){
      var showNewBadge_az = data.collections.find(item => item.title === 'DSI_NOV_AZ');
      var showNewBadge_ve = data.collections.find(item => item.title === 'DSI_NOV_VER');
      var showNewBadge_am = data.collections.find(item => item.title === 'DSI_NOV_AMA');
      var html = "";
      if(showNewBadge_az){html += '<div style="z-index:5;position: relative;"align="center"><span class="promotionTag siniva-tag" style="background-color: #fe6726; padding: 5px 15px; line-height: 1.3;"> Beneficio del IVA aplicado</span></div>';}
      else if(showNewBadge_ve){html += '<div style="z-index:5;position: relative;"align="center"><span class="promotionTag siniva-tag" style="background-color: #0055b8; padding: 5px 15px; line-height: 1.3;"> Descuento y beneficio <br> del IVA aplicado</span></div>';}
      else if(showNewBadge_am){html += '<div style="z-index:5;position: relative;"align="center"><span class="promotionTag siniva-tag" style="background-color: #519df5; padding: 5px 15px; line-height: 1.3;"> Sin beneficio de IVA</span></div>';}
      return html;
    }
  
    /* start-boost-38524 */
    itemHtml = itemHtml.replace(/{{customNewLabel_iva_img}}/g, buildNewLabel_iva_img(data));
    /* end-boost-38524 */

    // Imagenes porcentuales de descuento
    function buildNewLabel_iva(data){
      var showNewBadge = data.collections.find(item => item.title === 'DSI_NOV_20OFF');
      var showNewBadge_30 = data.collections.find(item => item.title === 'DSI_NOV_30OFF');
      var showNewBadge_40 = data.collections.find(item => item.title === 'DSI_NOV_40OFF');    
      var showNewBadge_50 = data.collections.find(item => item.title === 'DSI_NOV_50OFF');
      var showNewBadge_70 = data.collections.find(item => item.title === 'DSI_NOV_70OFF');
      var showNewBadge_10 = data.collections.find(item => item.title === 'DSI_NOV_10OFF');
      var showNewBadge_60 = data.collections.find(item => item.title === 'DSI_NOV_60OFF');
      var showNewBadge_80 = data.collections.find(item => item.title === 'DSI_NOV_80OFF');
      var html = "";
      if(showNewBadge){html += '<div class="img-percentage"><img style="max-width:50px; margin-top: 10px; height: auto;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS-05.png?v=1635427281"></div>';}
      else if(showNewBadge_40){html += '<div class="img-percentage"><img style="max-width:50px; margin-top: 10px; height: auto;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS-06.png?v=1635427281"></div>';}
      else if(showNewBadge_30){html += '<div class="img-percentage"><img style="max-width:50px; margin-top: 10px; height: auto;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/Imagen30.png?v=1638564090"></div>';}
      else if(showNewBadge_50){html += '<div class="img-percentage"><img style="max-width:50px; margin-top: 10px; height: auto;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS-07.png?v=1635427281"></div>';}
      else if(showNewBadge_70){html += '<div class="img-percentage"><img style="max-width:50px; margin-top: 10px; height: auto;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS-09.png?v=1635427281"></div>';}
      else if(showNewBadge_10){html += '<div class="img-percentage"><img style="max-width:50px; margin-top: 10px; height: auto;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS-11.png?v=1635427281"></div>';}
      else if(showNewBadge_60){html += '<div class="img-percentage"><img style="max-width:50px; margin-top: 10px; height: auto;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS-08.jpg?v=1655407765"></div>';}
      else if(showNewBadge_80){html += '<div class="img-percentage"><img style="max-width:50px; margin-top: 10px; height: auto;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS-11.jpg?v=1655407765"></div>';}
      //else{html += '<div class="box-bug" style="position:absolute; top: 0; right: 0rem; z-index:995; background-color: #ffffff; width: 50px; height: 50px;"></div>';}
      return html;
    }
  
    /* start-boost-38524 */
    itemHtml = itemHtml.replace(/{{customNewLabel_iva}}/g, buildNewLabel_iva(data));
    /* end-boost-38524 */
  
    //   CON IMAGENES (SOLO TEST, NO USAR LIVE)
    //     function buildNewLabel_iva_img(data){
    //       var showNewBadge_az = data.collections.find(item => item.title === 'DSI_NOV_AZ');
    //       var showNewBadge_ve = data.collections.find(item => item.title === 'DSI_NOV_VER');
    //       var showNewBadge_am = data.collections.find(item => item.title === 'DSI_NOV_AMA');
    //       var html = "";
    //       if(showNewBadge_az){html += '<div class="img-percentage"><img style="position:absolute; top: 10px; right: 10px; z-index:995; background-color: #ffffff; width: 50px; height: 50px;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS_IVA_APLICADO-01_6b4f7271-c5bc-477f-bef0-88f2af1f74c9.jpg?v=1635450894"></div>';}
    //       else if(showNewBadge_ve){html += '<div class="img-percentage"><img style="position:absolute; top: 10px; right: 10px; z-index:995; background-color: #ffffff; width: 50px; height: 50px;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS_IVA_DESCUENTO_94f349e0-3a54-4661-a2c8-2cf4c9753a8f.jpg?v=1635450893"></div>';}
    //       else if(showNewBadge_am){html += '<div class="img-percentage"><img style="position:absolute; top: 10px; right: 10px; z-index:995; background-color: #ffffff; width: 50px; height: 50px;" src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SELLOS_NO_APLICA_10c77012-3699-4f07-9358-631fe2351ebc.jpg?v=1635450893"></div>';}
    //       return html;
    //     }
  
    //------------------------------------------------------------------------------------------------------------------------------------
    //                                                             FIN DÍAS SIN IVA
    //------------------------------------------------------------------------------------------------------------------------------------
  
    //VTO
    function buildNewLabel_vto(data){
      var showNewBadge = data.collections.find(item => item.title === '');
      var html = "";
      if(data.tags.indexOf("VM")> -1){
        html += '<div class="vto-label" style="text-align:center;position:absolute; top: 10px; left:50%; margin-left: -62px; z-index:5;">';
          html += '<img src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/Icono_Probador_Virtual2_Oftalmicos_EJEMPLOS-03_1_007f079e-219d-426a-8670-37ecfcbf8f82.png?v=1742237013" style="max-width: 125px; height: auto;">';
          html += '</div>';
      }
      return html;
    }
  
    /* start-boost-38524 */
    itemHtml = itemHtml.replace(/{{customNewLabel_vto}}/g, buildNewLabel_vto(data));
    /* end-boost-38524 */
  
       //SALE
    /*function buildNewLabel_SALE(data){
      var showNewBadge = data.collections.find(item => item.title === 'SALE');
      var html = "";
      if(showNewBadge){
        html += '<div class="SALE-label" style="text-align:right;position:absolute; top: 10px; left:50%; margin-left: -62px; z-index:5;">';
          html += '<img src="https://cdn.shopify.com/s/files/1/0031/1817/0157/files/SALE.png?v=1610153076" style="max-width: 125px; height: auto;">';
          html += '</div>';
      }
      return html;
    }*/
  
    /* start-boost-38524 */
    //itemHtml = itemHtml.replace(/{{customNewLabel_SALE}}/g, buildNewLabel_SALE(data));
    /* end-boost-38524 */

    // Add Label
    var itemLabelsHtml = '';
    // if (soldOut) {
    //     itemLabelsHtml += '<span class="productitem--badge badge--soldout">' + bcSfFilterConfig.label.sold_out +'</span>';
    // } else {
    //     if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
    //         var savePrice = data.compare_at_price_min - data.price_min;            
    //         var savePriceHtml = '<span class="money" data-price-money-saved>' + this.formatMoney(savePrice) + '</span>';
    //         var percentSavePriceHtml = '<span data-price-percent-saved>' + data.percent_sale_min + '</span>';
    //       if(data.tags.indexOf("100%") > -1){
    //         //itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>10';
    //         itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
    //         switch (bcSfFilterConfig.custom.product_sales_badge_style) {
    //             case 'percentile': itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml); break;
    //             case 'money': itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice)); break;
    //             default: itemLabelsHtml += bcSfFilterConfig.label.sale; break;
    //         }
    //         itemLabelsHtml += '</span>';
    //       }
    //       else{
    //         itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
    //         switch (bcSfFilterConfig.custom.product_sales_badge_style) {
    //             case 'percentile': itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml); break;
    //             case 'money': itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice)); break;
    //             default: itemLabelsHtml += bcSfFilterConfig.label.sale; break;
    //         }
    //         itemLabelsHtml += '</span>';
    //       }
          
    //     }
    // }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var priceHtml = '';
    var classVaries = priceVaries ? 'price--varies' : '';
    var visibleClass = onSale || bcSfFilterConfig.custom.emphasize_price ? 'visible' : '';
    priceHtml += '<div class="productitem--price ' + classVaries + ' "  style="position: relative">';
    priceHtml += '<div class="price--compare-at ' + visibleClass + '" data-price-compare-at style="margin-top: 20px;">';
    var comparePrice = '<span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span>';
    if (priceVaries && onSale){
        priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, comparePrice);
    } else {
        if (onSale) {
            priceHtml += comparePrice;
        } else {
            if (bcSfFilterConfig.custom.emphasize_price) {
                priceHtml += '<span class="price--spacer"></span>';
            } else {
                priceHtml += '<span class="money"></span>';
            }
        }
    }
    priceHtml += '</div>';
    priceHtml += '<div class="price--main" data-price>';
    if(data.product_type == 'Bonos'){// Adding statements to Gift Cards
        if (gc_perc > 0 && gc_date_init <= today_date && today_date <= gc_date_end) { // All this info in GiftCards Module
            onSale = true;
            var gc_disc = 100 - gc_perc;
            var gc_disc_string = '0.'+gc_disc;
            gc_disc = parseFloat(gc_disc_string)
            var price = '<span class="money">' + this.formatMoney(data.price_min * gc_disc)+ '</span>'; 
        }else{
            var price = '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        } 
    }else{
        var price = '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
    }
    if (priceVaries) {
        priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, price); 
    } else {
      
        if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
            var savePrice = data.compare_at_price_min - data.price_min;            
            var savePriceHtml = '<span class="money" data-price-money-saved>' + this.formatMoney(savePrice) + '</span>';
            if(data.product_type == 'Bonos'){
                if(gc_perc > 0 && gc_date_init <= today_date && today_date <= gc_date_end) { // All this info in GiftCards Module
                    var percentSavePriceHtml = '<span data-price-percent-saved>' + gc_perc + '</span>';
                }else{
                    var percentSavePriceHtml = '<span data-price-percent-saved>' + data.percent_sale_min + '</span>';
                }
            }else{
                var percentSavePriceHtml = '<span data-price-percent-saved>' + data.percent_sale_min + '</span>';
            }
            if(data.tags.indexOf("100%") > -1 || data.product_type.indexOf("Contacto") > -1 || data.product_type.indexOf("Cosméticos") > -1){}else{
                itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
                switch (bcSfFilterConfig.custom.product_sales_badge_style) {
                    case 'percentile': itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml); break;
                    case 'money': itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice)); break;
                    default: itemLabelsHtml += bcSfFilterConfig.label.sale; break;
                }
                itemLabelsHtml += '</span>';
            }
          
        }
        priceHtml += price + itemLabelsHtml;
    }
    priceHtml += '</div>';
    priceHtml += '</div>';
    // Add emphasize price
    var emphasizePriceHtml = '';
    var noEmphasizePriceHtml = '';
    if (bcSfFilterConfig.custom.emphasize_price) {
        emphasizePriceHtml += priceHtml;
    } else {
        noEmphasizePriceHtml += priceHtml;
    }
    itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
    itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);

    // Add vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_vendor && data.vendor !== '' && (data.tags.indexOf("Lentes de contactos") < 1) ) 
    {
     
      /*if(data.tags.indexOf("Lentes de contacto") > 0){
        itemVendorHtml += '<a class="productitem--vendor">SKU lentes </a>';
        itemVendorHtml += '<a class="productitem--vendor">' + data.variants[0].sku +'</a>';
      }*/
      if(data.tags.indexOf("Miopía e Hipermetropía") > -1 || data.tags.indexOf("Miopía") > -1){
        itemVendorHtml += '<a class="productitem--vendor"><b>Indicado para:</b> Miopía e Hipermetropía</a>'
      }
      else if(data.tags.indexOf("Astigmatismo") > -1){
        itemVendorHtml += '<a class="productitem--vendor"><b>Indicado para:</b> Astigmatismo</a>'
      }
      else if(data.tags.indexOf("Multifocal") > -1){
        itemVendorHtml += '<a class="productitem--vendor"><b>Indicado para:</b> Presbicia</a>'
      }
      else if(data.tags.indexOf("Lentes Cosméticos") > -1){
        itemVendorHtml += '<a class="productitem--vendor"><b>Indicado para:</b> Cosméticos</a>'
      }
      else
      {
        /*if(data.tags.indexOf("pack") > -1)
        {
          itemVendorHtml += '<p style="background-color:#0fa2bf!important;color:#fff!important;text-align:center!important; padding:2px;">Comprando tu pack de lentes</p>';
        }*/
      itemVendorHtml += '<a class="productitem--vendor">SKU </a>';
      itemVendorHtml += '<a class="productitem--vendor">' + data.variants[0].sku +'</a>';
      itemVendorHtml += '<p class="productitem--vendor">';
      if(data.tags.indexOf("Unisex") > -1){
        itemVendorHtml += 'Género Unisex';
      }else if(data.tags.indexOf("Niños") > -1){
        itemVendorHtml += 'Niños'
      }else if(data.tags.indexOf("Mujer") > -1){
        itemVendorHtml += 'Género Mujer';
      }else if(data.tags.indexOf("Hombre") > -1){
        itemVendorHtml += 'Género Hombre';
      }
      
      itemVendorHtml += '</p>';
    }
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
  
    //Add Replace (Tiempo de uso)
    var itemReplaceHtml = '';
    if(data.tags.indexOf("Diario") > -1 ){
        itemReplaceHtml += '<a class="productitem--vendor"><b>Tiempo de uso:</b> Diario</a></h3>'; 
    }
    else if(data.tags.indexOf("Quincenal") > -1){
        itemReplaceHtml += '<a class="productitem--vendor"><b>Tiempo de uso:</b> Quincenal</a></h3>';
    }
    else if(data.tags.indexOf("Mensual") > -1){
        itemReplaceHtml += '<a class="productitem--vendor"><b>Tiempo de uso:</b> Mensual</a></h3>';
        if(data.tags.indexOf("Lentes Cosméticos") > -1){itemReplaceHtml +='<br><a style="background-color:#fff!important;color:red!important;"><b>¡Atención!</b><br> No son lentes de contacto formulados.</a></h3>'};
    }else{}
    itemHtml = itemHtml.replace(/{{itemReplace}}/g, itemReplaceHtml);
  
  
    // Add review rating
    var itemReviewsHtml = '';
    if (bcSfFilterConfig.custom.product_ratings_reviews) {
        itemReviewsHtml +=  '<div class="productitem--ratings">' +
                                '<span class="shopify-product-reviews-badge" data-id="{{itemId}}">' +
                                    '<span class="spr-badge">' +
                                        '<span class="spr-starrating spr-badge-starrating">' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                        '</span>' +
                                    '</span>' +
                                '</span>' +
                            '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
  
  var itemCollections = data.collections.map(function(collection){
      return collection.handle;
  });
    itemHtml = itemHtml.replace(/{{itemCollections}}/g, itemCollections.join());

    // Add quickBtn
    var quickBtnHtml = '';
    var has_variants = firstVariant['option_title'] == 'Default Title' ? false : true;
    var show_modal = bcSfFilterConfig.custom.show_modal;
    if (bcSfFilterConfig.custom.enable_quick_look == true || bcSfFilterConfig.custom.enable_quick_buy == true) {
        var quick_look_text = bcSfFilterConfig.label.quick_look_text;
        var quick_buy_text = bcSfFilterConfig.label.quick_buy_text;
        var quick_look_classes = 'productitem--action-trigger button-secondary';
        var quick_buy_classes = 'productitem--action-trigger productitem--action-atc button-primary';
        if (has_variants) {
            quick_buy_text = bcSfFilterConfig.label.quick_choose_options;
            show_modal = true;
        }
        if (!data.available) {
            quick_buy_text = bcSfFilterConfig.label.sold_out;
            quick_buy_classes = quick_buy_classes + ' disabled';
        }
        //if (itemCollections.includes("lentes-de-contacto") || itemCollections.includes("tienda-online-lentes_de_contacto")) { 
        quick_buy_text = 'Ver Producto';
          quick_buy_classes = quick_buy_classes + ' disabled';
      //}
        quickBtnHtml += '<div class="productitem--actions" data-product-actions>';
        if (bcSfFilterConfig.custom.enable_quick_look) {
            quickBtnHtml += '<div class="productitem--action">' +
                                '<button class="'+ quick_look_classes +'" data-quickshop-full data-id="{{itemId}}" type="button" tabindex="1">' + quick_look_text +
                                '</button>' +
                            '</div>';
        }
        if (bcSfFilterConfig.custom.enable_quick_buy) {
            
            if (!has_variants) {
                var temp = ' data-quick-buy ';
            } else {
                var temp = ' data-quickshop-slim ';
            }

               quickBtnHtml += '<div class="productitem--action">' +
                '<form action="{{itemUrl}}">' +
                '<button class="' + quick_buy_classes + '" tabindex="1" type="submit" ';
                if (!data.available) {
                    quickBtnHtml += ' disabled';
                }
                quickBtnHtml += '>';
                quickBtnHtml += '<span class="atc-button--text">' + quick_buy_text + '</span>';
                quickBtnHtml += '</button>';
                quickBtnHtml += '</form>';
                quickBtnHtml += '</div>';

             
        }

        quickBtnHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{quickBtn}}/g, quickBtnHtml);
  
  

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    // Build content for Modal
    var quickUrl = this.buildProductItemUrl(data) + '?view=bc-sf-quickview';
    jQ.ajax({url: quickUrl, success: function(result){
        jQ('#' + data.handle).after(result);
        jQ('#' + data.handle).find('.productitem--action').css('display', 'block');

        if (index == totalProduct) {
            if(typeof bcSections != 'undefined'){
              var sections = new bcSections();
              if(typeof bcStaticCollection != 'undefined'){
                sections.register('static-collection', function (section) {
                  return new bcStaticCollection(section);
                });
              }              
            }            
        }
    }});

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add custom class
    var customClass = 'productgrid--item imagestyle--' + bcSfFilterConfig.custom.product_grid_image_style;
    if (onSale) customClass += ' productitem--sale';
    if (bcSfFilterConfig.custom.emphasize_price) customClass += ' productitem--emphasis';
    itemHtml = itemHtml.replace(/{{customClass}}/g, customClass);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '512x') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Label
    var itemLabelsHtml = '';
    if (soldOut) {
        itemLabelsHtml += '<span class="productitem--badge badge--soldout">' + bcSfFilterConfig.label.sold_out +'</span>';
    } else {
        if (onSale && bcSfFilterConfig.custom.product_sales_badge) {
            var savePrice = data.compare_at_price_min - data.price_min;
            var percentSavePrice = Math.round(savePrice * 100 / data.compare_at_price_max);
            var savePriceHtml = '<span class="money" data-price-money-saved>' + this.formatMoney(savePrice) + '</span>';
            var percentSavePriceHtml = '<span data-price-percent-saved>' + percentSavePrice + '</span>';
            
          
          
          
          itemLabelsHtml += '<span class="productitem--badge badge--sale" data-badge-sales>';
            switch (bcSfFilterConfig.custom.product_sales_badge_style) {
                case 'percentile': itemLabelsHtml += bcSfFilterConfig.label.sale_percentile_html.replace(/{{ saved }}/g, percentSavePriceHtml); break;
                case 'money': itemLabelsHtml += bcSfFilterConfig.label.sale_money_html.replace(/{{ saved }}/g, this.formatMoney(savePrice)); break;
                default: itemLabelsHtml += bcSfFilterConfig.label.sale; break;
            }
            itemLabelsHtml += '</span>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
  
    // Add Badge
    var itemBadgeHtml = '';
    if (data.tags.indexOf("2+2")> -1) 
    {
      itemBadgeHtml += '<div align="center"><span style="text-decoration: none; color:white; background-color: #ff0005; margin-bottom: 10px; padding-right: 15px; padding-left: 15px; text-decoration: none;">APLICA 2+2</span><br></div>';
    }
    
    else if (data.tags.indexOf("promociones")> -1)
    {
      itemBadgeHtml += '<div align="center"><span style="text-decoration: none; color:white; background-color: #ff0005; margin-bottom: 10px; padding-right: 15px; padding-left: 15px; text-decoration: none;">2 Cajas-15% DCTO</span><br></div><div align="center"><span style="text-decoration: none; color:white; background-color: #ff0005; margin-bottom: 10px; padding-right: 15px; padding-left: 15px; text-decoration: none;">APLICA 3+1</span><br></div>';
    }
    itemHtml = itemHtml.replace(/{{itemBadge}}/g, itemBadgeHtml);
  

    // Add Price
    var priceHtml = '';
    var classVaries = priceVaries ? 'price--varies' : '';
    var visibleClass = onSale || bcSfFilterConfig.custom.emphasize_price ? 'visible' : '';
    priceHtml += '<div class="productitem--price ' + classVaries + '">';
    priceHtml += '<div class="price--compare-at ' + visibleClass + '" data-price-compare-at>';
    var comparePrice = '<span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span>';
    if (priceVaries && onSale){
        priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, comparePrice);
    } else {
        if (onSale) {
            priceHtml += comparePrice;
        } else {
            if (bcSfFilterConfig.custom.emphasize_price) {
                priceHtml += '<span class="price--spacer"></span>';
            } else {
                priceHtml += '<span class="money"></span>';
            }
        }
    }
    priceHtml += '</div>';
    priceHtml += '<div class="price--main" data-price>';
    var price = '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
    if (priceVaries) {
        priceHtml += bcSfFilterConfig.label.range_html.replace(/{{ price }}/g, price);
    } else {
        priceHtml += price;
    }
    priceHtml += '</div>';
    priceHtml += '</div>';

    // Add quickBtn
    var quickBtnHtml = '';
    var has_variants = firstVariant['option_title'] == 'Default Title' ? false : true;
    var show_modal = bcSfFilterConfig.custom.show_modal;
    if (bcSfFilterConfig.custom.enable_quick_look == true || bcSfFilterConfig.custom.enable_quick_buy == true) {
        var quick_look_text = bcSfFilterConfig.label.quick_look_text;
        var quick_buy_text = bcSfFilterConfig.label.quick_buy_text;
        var quick_look_classes = 'productitem--action-trigger button-secondary';
        var quick_buy_classes = 'productitem--action-trigger productitem--action-atc button-primary';
        if (has_variants) {
            quick_buy_text = bcSfFilterConfig.label.quick_choose_options;
            show_modal = true;
        }
        if (!data.available) {
            quick_buy_text = bcSfFilterConfig.label.sold_out;
            quick_buy_classes = quick_buy_classes + ' disabled';
        }
        quickBtnHtml += '<div class="productitem--actions" data-product-actions>';
        quickBtnHtml += '<div class="productitem--listview-price">' +
                            '{{emphasizePrice}}' +
                        '</div>' +
                        '<div class="productitem--listview-badge"></div>';
        if (bcSfFilterConfig.custom.enable_quick_look) {
            quickBtnHtml += '<div class="productitem--action">' +
                                '<button class="'+ quick_look_classes +'" data-quickshop-full data-id="{{itemId}}" type="button" tabindex="1">' + quick_look_text +
                                '</button>' +
                            '</div>';
        }
        if (bcSfFilterConfig.custom.enable_quick_buy) {
            if (!has_variants) {
                var temp = ' data-quick-buy ';
            } else {
                var temp = ' data-quickshop-slim ';
            }
            quickBtnHtml += '<div class="productitem--action">' +
                                '<button class="' + quick_buy_classes + '" tabindex="1" type="button" aria-label="' + quick_buy_text + '"' +
                                temp + 'data-variant-id="' + data.variants[0].id + '"';
            if (!data.available) {
                quickBtnHtml += ' disabled';
            }
            quickBtnHtml += '>';
            quickBtnHtml += '<span class="atc-button--text">' + quick_buy_text + '</span>';
            quickBtnHtml += '<span class="atc-button--icon">';
            quickBtnHtml += '<svg aria-hidden="true" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" > <g fill-rule="nonzero" fill="currentColor"> <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"></path><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"></path> </g> </svg>';
            quickBtnHtml += '</span>';
            quickBtnHtml += '</button>';
            quickBtnHtml += '</div>';
        }

        quickBtnHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{quickBtn}}/g, quickBtnHtml);

    // Add emphasize price
    var emphasizePriceHtml = '';
    var noEmphasizePriceHtml = '';
    if (bcSfFilterConfig.custom.emphasize_price) {
        emphasizePriceHtml += priceHtml;
    } else {
        noEmphasizePriceHtml += priceHtml;
    }
    itemHtml = itemHtml.replace(/{{emphasizePrice}}/g, emphasizePriceHtml);
    itemHtml = itemHtml.replace(/{{noEmphasizePrice}}/g, noEmphasizePriceHtml);

    // Add vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_vendor && data.vendor !== '') {
        itemVendorHtml += '<p class="productitem--vendor">' + data.vendor + '</p>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add review rating
    var itemReviewsHtml = '';
    if (bcSfFilterConfig.custom.product_ratings_reviews) {
        itemReviewsHtml +=  '<div class="productitem--ratings">' +
                                '<span class="shopify-product-reviews-badge" data-id="{{itemId}}">' +
                                    '<span class="spr-badge">' +
                                        '<span class="spr-starrating spr-badge-starrating">' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                            '<i class="spr-icon spr-icon-star-empty"></i>' +
                                        '</span>' +
                                    '</span>' +
                                '</span>' +
                            '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

    // Add description
    var itemDescriptionHtml = '';
    if (data.description && data.description.length > 0) {
        itemDescriptionHtml +=  '<div class="productitem--description">' +
                                    '<p>' + bcsffilter.truncateByChar(data.description, 150) + '</p>' +
                                '</div>';
        if (data.description.length > 150) {
            itemDescriptionHtml += '<a href="{{itemUrl}}" class="productitem--link">' + bcSfFilterConfig.label.view_details + '</a>';
        }
    }
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    // Build content for Modal
    var quickUrl = this.buildProductItemUrl(data) + '?view=bc-sf-quickview';
    jQ.ajax({url: quickUrl, success: function(result){
        jQ('#' + data.handle).after(result);
        jQ('#' + data.handle).find('.productitem--action').css('display', 'block');

        if (index == totalProduct) {
            var sections = new bcSections();
            sections.register('static-collection', function (section) {
                return new bcStaticCollection(section);
            });
        }
    }});
  
 

    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
    if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
        jQ(this.selector.topShowLimit).html('');

        var numberList = this.getSettingValue('general.showLimitList');
        if (numberList != '') {
            // Build content
            var showLimitItemsHtml = '';
            var arr = numberList.split(',');
            for (var k = 0; k < arr.length; k++) {
                if (arr[k] == this.queryParams.limit) {
                    showLimitItemsHtml += '<li><a class="utils-showby-item active" href="' + arr[k] +'">' + arr[k] + '</a></li>';
                } else {
                    showLimitItemsHtml += '<li><a class="utils-showby-item" href="' + arr[k] +'">' + arr[k] + '</a></li>';
                }
            }
            var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
            jQ(this.selector.topShowLimit).html(html);
        }
    }
};

BCSfFilter.prototype.buildShowLimitEvent = function() {
    var _this = this;
    jQ(this.selector.topShowLimit + ' li a').click(function(e) {
        onInteractWithToolbar(e, 'limit', _this.queryParams.limit, jQ(this).attr('href'));
    })
};

/************************** END BUILD TOOLBAR **************************/

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;
        var delimiter = '<span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"/></svg></span>';
        var breadcrumbHtml = '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> ';
        breadcrumbHtml += delimiter;
        breadcrumbHtml += ' <span>' + colInfo.title + '</span>';
        jQ('.breadcrumbs-container').html(breadcrumbHtml);
    }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    var itemHtml = '<span class="utils-viewtoggle-label">' + bcSfFilterConfig.label.view_as_title + ' </span>';
    itemHtml += '<button class="active bc-sf-filter-display-grid" data-display-type="' + this.buildToolbarLink('display', 'list', 'grid') + '">';
    itemHtml += '<svg class="icon-grid " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">      <path fill="currentColor" fill-rule="nonzero" d="M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v16h16V2H2zm3 3h4v4H5V5zm6 0h4v4h-4V5zm-6 6h4v4H5v-4zm6 0h4v4h-4v-4z"></path>    </svg>';
    itemHtml == '</button>';
    itemHtml += '<button class="bc-sf-filter-display-list" data-display-type= "' + this.buildToolbarLink('display', 'grid', 'list') + '">';
    itemHtml += '<svg class="icon-list " aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">      <path fill="currentColor" fill-rule="nonzero" d="M2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 2v16h16V2H2zm3 3h10v2H5V5zm0 4h10v2H5V9zm0 4h10v2H5v-2z"></path>    </svg>';
    itemHtml == '</button>';

    jQ(this.selector.topDisplayType).html(itemHtml);

    // Active current display type
    jQ(this.selector.topDisplayType).find('button').removeClass('active');
    if (this.queryParams.display == 'list') {
        jQ(this.selector.topDisplayType).find('button.bc-sf-filter-display-list').addClass('active');
    } else if (this.queryParams.display == 'grid') {
        jQ(this.selector.topDisplayType).find('button.bc-sf-filter-display-grid').addClass('active');
    }
};

// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
    var _this = this;
    jQ(this.selector.topDisplayType + ' button').unbind('click');
    jQ(this.selector.topDisplayType + ' button').click(function(e) {
         e.preventDefault();
        _this.internalClick = true;
        jQ(this).parent().children('button').removeClass('active');
        jQ(this).addClass('active');
        var newUrl = jQ(this).attr('data-display-type');
        if (newUrl.indexOf('list') != -1) {
            jQ('.productgrid--outer').addClass('productgrid-listview');
        } else {
            jQ('.productgrid--outer').removeClass('productgrid-listview');
        }
        _this.onChangeData(newUrl, 'display');
    })
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    // var sections = new Sections();
    // sections.register('static-collection', function (section) {
    //     return new StaticCollection(section);
    // });

    // Integrate Product Reviews
    if (bcSfFilterConfig.custom.product_ratings_reviews) {
        !function(){var e=function(e){var t={exports:{}};return e.call(t.exports,t,t.exports),t.exports};e(function(){"use strict";window.innerShiv=function(){function e(e,t,r){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(r)?e:t+"></"+r+">"}var t,r,a=document,i="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(n,s){if(!t&&(t=a.createElement("div"),t.innerHTML="<nav></nav>",r=1!==t.childNodes.length)){for(var o=a.createDocumentFragment(),d=i.length;d--;)o.createElement(i[d]);o.appendChild(t)}if(n=n.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,e),t.innerHTML=(o=n.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+n+"</table>":n,o=o?t.getElementsByTagName(o[1])[0].parentNode:t,!1===s)return o.childNodes;for(var d=a.createDocumentFragment(),u=o.childNodes.length;u--;)d.appendChild(o.firstChild);return d}}()});(function(){window.SPR=function(){function e(){}return e.shop=Shopify.shop,e.host="//productreviews.shopifycdn.com",e.version="v4",e.api_url=e.host+"/proxy/"+e.version,e.badgeEls=[],e.reviewEls=[],e.elSettings={},e.$=void 0,e.extraAjaxParams={shop:e.shop},e.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},e.loadStylesheet=function(){var e,t;return t=document.createElement("link"),t.setAttribute("rel","stylesheet"),t.setAttribute("type","text/css"),t.setAttribute("href","https://productreviews.shopifycdn.com/assets/v4/spr-5a2d2fd286dca8042a3a5a76bc9032c64c52a2792a734307c76740d012641514.css"),t.setAttribute("media","screen"),e=document.getElementsByTagName("head")[0],e.appendChild(t)},e.initRatingHandler=function(){return e.$(document).on("mouseover mouseout","form a.spr-icon-star",function(t){var r,a,i;return r=t.currentTarget,i=e.$(r).attr("data-value"),a=e.$(r).parent(),"mouseover"===t.type?(a.find("a.spr-icon:lt("+i+")").addClass("spr-icon-star-hover"),a.find("a.spr-icon:gt("+(i-1)+")").removeClass("spr-icon-star-hover")):a.find("a.spr-icon").removeClass("spr-icon-star-hover")})},e.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,function(e){return function(t,r){var a;return a=e.$(r).attr("data-id"),e.elSettings[a]={},e.elSettings[a].reviews_el="#"+(e.$(r).attr("data-reviews-prefix")?e.$(r).attr("data-reviews-prefix"):"reviews_"),e.elSettings[a].form_el="#"+(e.$(r).attr("data-form-prefix")?e.$(r).attr("data-form-prefix"):"form_")}}(this))},e.loadProducts=function(){return this.$.each(this.reviewEls,function(e){return function(t,r){var a,i;if(a=e.$(r).attr("data-id"),"false"!==e.$(r).attr("data-autoload"))return i=e.$.extend({product_id:a,version:e.version},e.extraAjaxParams),e.$.get(e.api_url+"/reviews/product",i,e.productCallback,"jsonp")}}(this))},e.loadBadges=function(){var e,t,r,a,i;if(r=this.$.map(this.badgeEls,function(e){return function(t){return e.$(t).attr("data-id")}}(this)),r.length>0){for(t=7,i=[];(e=r.splice(0,t)).length>0;)a=this.$.extend(this.extraAjaxParams,{product_ids:e}),i.push(this.$.get(this.api_url+"/reviews/badges",a,this.badgesCallback,"jsonp"));return i}},e.pageReviews=function(e){var t,r,a;return a=this.$(e).data("product-id"),r=this.$(e).data("page"),t=this.$.extend({page:r,product_id:a},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",t,this.paginateCallback,"jsonp"),!1},e.submitForm=function(e){var t;return t=this.$(e).serializeObject(),t=this.$.extend(t,this.extraAjaxParams),t=this.$.param(t),t=t.replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:t,success:this.formCallback,beforeSend:function(e){return function(){return e.$(".spr-button-primary").attr("disabled","disabled")}}(this),complete:function(e){return function(){return e.$(".spr-button-primary").removeAttr("disabled")}}(this)}),!1},e.reportReview=function(e){var t;return confirm("Are you sure you want to report this review as inappropriate?")&&(t=this.$.extend({id:e},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",t,this.reportCallback,"jsonp")),!1},e.toggleReviews=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-reviews").toggle()},e.toggleForm=function(e){var t;return t=this.$("#shopify-product-reviews[data-id='"+e+"']"),t.find(".spr-form").toggle()},e.setRating=function(e){var t,r,a;return t=this.$(e).parents("form"),a=this.$(e).attr("data-value"),r=this.$(e).parent(),t.find("input[name='review[rating]']").val(a),this.setStarRating(a,r)},e.setStarRating=function(e,t){return t.find("a:lt("+e+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),t.find("a:gt("+(e-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},e.badgesCallback=function(t){var r;return r=t.badges,e.$.map(e.badgeEls,function(t){var a;if(a=e.$(t).attr("data-id"),r[a]!==undefined)return e.$(t).replaceWith(r[a]),e.triggerEvent("spr:badge:loaded",{id:a})})},e.productCallback=function(t){var r;return r=t.remote_id.toString(),e.renderProduct(r,t.product),e.renderForm(r,t.form),e.renderReviews(r,t.reviews)},e.renderProduct=function(e,t){return this.$.map(this.reviewEls,function(r){return function(a){if(e===r.$(a).attr("data-id"))return r.$(a).html(innerShiv(t,!1)),r.triggerEvent("spr:product:loaded",{id:e})}}(this))},e.renderForm=function(e,t){var r;return r=this.$(this.elSettings[e].form_el+e),r.html(t),this.triggerEvent("spr:form:loaded",{id:e})},e.renderReviews=function(t,r){var a;return a=e.$(e.elSettings[t].reviews_el+t),a.html(r),e.triggerEvent("spr:reviews:loaded",{id:t})},e.formCallback=function(t){var r,a,i,n;return n=t.status,i=t.remote_id,a=t.form,r=e.$(e.elSettings[i].form_el+i),r.html(a),"failure"===n&&e.initStarRating(r),"success"===n&&e.$("#shopify-product-reviews[data-id='"+i+"'] .spr-summary-actions-newreview").hide(),e.triggerEvent("spr:form:"+n,{id:i})},e.initStarRating=function(e){var t,r,a;if((a=e.find("input[name='review[rating]']"))&&a.val())return r=a.val(),t=e.find(".spr-starrating"),this.setStarRating(r,t)},e.paginateCallback=function(t){var r,a;return a=t.remote_id.toString(),r=t.reviews,e.renderReviews(a,r)},e.reportCallback=function(t){var r;return r="#report_"+t.id,e.$(r).replaceWith("<span class='spr-review-reportreview'>"+e.$(r).attr("data-msg")+"</span>")},e.loadjQuery=function(t){return e.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return e.$=jQuery.noConflict(!0),t()})},e.loadScript=function(e,t){var r;return r=document.createElement("script"),r.type="text/javascript",r.readyState?r.onreadystatechange=function(){if("loaded"===r.readyState||"complete"===r.readyState)return r.onreadystatechange=null,t()}:r.onload=function(){return t()},r.src=e,document.getElementsByTagName("head")[0].appendChild(r)},e.loadjQueryExtentions=function(e){return e.fn.serializeObject=function(){var t,r;return t={},r=this.serializeArray(),e.each(r,function(){return t[this.name]?(t[this.name].push||(t[this.name]=[t[this.name]]),t[this.name].push(this.value||"")):t[this.name]=this.value||""}),t}},e.triggerEvent=function(e,t){return this.$(document).trigger(e,t)},e}(),function(){SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}()}).call(this)}("undefined"!=typeof global?global:"undefined"!=typeof window&&window);
    }
    if (typeof bcImages !== 'undefined') {
        bcImages();
    }
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    if (this.queryParams.display == 'list') {
        jQ('.productgrid--outer').addClass('productgrid-listview');
    } else {
        jQ('.productgrid--outer').removeClass('productgrid-listview');
    }
    //jQ('#bc-sf-filter-products').css('display', 'flex');

    // Build Breadcrumb of Search page
    if (this.isSearchPage()) {
        var content = '';
        var searchTerm = this.escape(this.getSearchTerm());
        if (searchTerm != null) {
            content = bcSfFilterConfig.label.search_breadcrumbs_count_other;
            if (data.total_product == 1) {
                content = bcSfFilterConfig.label.search_breadcrumbs_count_one;
            } else if (data.total_product == 0) {
                content = bcSfFilterConfig.label.search_breadcrumbs_count_zero;
            }
            content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
            content = content.replace(/&lt;strong&gt;/g, '<strong>').replace(/&lt;\/strong&gt;/g, '</strong>');
        }
        jQ('.breadcrumbs-container span:last-child').html(content);
        jQ('.breadcrumbs-container span').css('display', 'inline-block');
    }
};

// Fix: Recently Viewed
// + empire.js
//
// + Find: RecentlyViewed và recentlyViewed = JSON.parse
//
// + Replace by recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'));
// if(typeof bcsffilter === 'undefined' || (typeof bcsffilter !== 'undefined' && bcsffilter.queryParams.event_type == 'init' && bcsffilter.hasFilterOptionParam === false)){


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

BCSfFilter.prototype.prepareProductData = function(data) { var countData = data.length; for (var k = 0; k < countData; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } } data[k]['url'] = '/products/' + data[k].handle; var optionsArr = []; var countOptionsWithValues = data[k]['options_with_values'].length; for (var i = 0; i < countOptionsWithValues; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) } data[k]['options'] = optionsArr; if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) { var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim(); function updateMultiCurrencyPrice(oldPrice, newPrice) { if (typeof newPrice != 'undefined') { return newPrice; } return oldPrice; } data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]); data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]); data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]); data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]); } data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; var firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0] } else { var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } } data[k]['selected_or_first_available_variant'] = firstVariant; var countVariants = data[k]['variants'].length; for (var i = 0; i < countVariants; i++) { var variantOptionArr = []; var count = 1; var variant = data[k]['variants'][i]; var variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { var countVariantOptions = variantOptions.length; for (var j = 0; j < countVariantOptions; j++) { var temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) } data[k]['variants'][i]['options'] = variantOptionArr } data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 } data[k]['description'] = data[k]['content'] = data[k]['body_html']; if(data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0){ data[k].tags = data[k]['original_tags'].slice(0); }} return data };

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */